export default "__VITE_ASSET__B9gZrKZ2__"